import React from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';

const MapContainer = (props) => {
  return (
    <Map
      initialCenter={{
        lat: -36.84846,
        lng: 174.763332
      }}
      google={props.google} zoom={13}>
      <Marker
        name={'Auckland'}
        position={{ lat: -36.84846, lng: 174.763332 }} />
      <Marker />
    </Map>
  );
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyBOmCSef6IuA4_W5-4yk2FHdeTUbZjHe-c"
})(MapContainer)